import { Outlet } from "react-router-dom";
import { HeaderFr } from "./HeaderFr";
import { FooterFr } from "./FooterFr";
import { StickyBar } from "./StickyBar";

export const LayoutFr = () => (
  <div className="min-h-screen bg-[#0D0E11] text-gray-200 font-body">
    <HeaderFr />
    <main>
      <Outlet />
    </main>
    <FooterFr />
    <StickyBar label="Répartition 24/7 — Nous répondons" />
  </div>
);
